import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/payment-methods/new/loading';

export const Route = createFileRoute('/_private/settings/payment-methods/new')({
  component: Loading,
});
